const featureFlagConfig = {
  appName: 'production',
  host: 'https://git.homelabblog.com/api/v4/feature_flags/unleash/17',
  instanceId: 'LJ1zrQzatnrYoZe_PVes'
};

export default featureFlagConfig;